export const POST_ACHIEVEMENTS_CHECK_SUCCESS = 'POST_ACHIEVEMENTS_CHECK_SUCCESS';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
export const LOADING_MESSAGE = '加载中...';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
